import { render } from "./FooterProductCategoriesComponent.vue?vue&type=template&id=2c539168"
import script from "./FooterProductCategoriesComponent.vue?vue&type=script&lang=js"
export * from "./FooterProductCategoriesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/staderecord/assets/js/components/FooterProductCategoriesComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c539168"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c539168', __exports__)) {
    api.reload('2c539168', __exports__)
  }
  
  module.hot.accept("./FooterProductCategoriesComponent.vue?vue&type=template&id=2c539168", () => {
    api.rerender('2c539168', render)
  })

}


export default __exports__